import {ProductPageApp} from '../../../productPage/components/ProductPageApp/ProductPageApp';
import {withGlobalPropsProvider} from '../../../productPage/providers/globalPropsProvider';

export default withGlobalPropsProvider(ProductPageApp);
